import React, { useState } from 'react';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { Checkbox, TextButton, Text } from 'wix-ui-tpa/cssVars';
import { classes } from '../Widget.st.css';
import { TEXT_DIRECTION } from '../../../../constants';

interface PublicProfileCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const PublicProfileCheckbox: React.FC<PublicProfileCheckboxProps> = ({
  checked,
  onChange,
}) => {
  const { t } = useTranslation();
  const { isRTL } = useEnvironment();
  const [isExpanded, setIsExpanded] = useState(false);

  const shortText = t(
    'memberAuthentication.uouScreens.signUpForm.checkbox.publicProfile',
  );
  const expandedText = t(
    'memberAuthentication.uouScreens.signupForm.checkbox.publicProfile.showMore.text',
  );
  const showMoreText = t(
    'memberAuthentication.uouScreens.signUpForm.checkbox.publicProfile.readMore',
  );
  const showLessText = t(
    'memberAuthentication.uouScreens.signupForm.checkbox.publicProfile.showLess',
  );

  return (
    <div
      data-hook="signup-public-profile-section"
      className={classes.publicProfileContainer}
      dir={isRTL ? TEXT_DIRECTION.RTL : TEXT_DIRECTION.LTR}
    >
      <Checkbox
        checked={checked}
        onChange={(e) => onChange(e.checked)}
        data-hook="signup-public-profile-checkbox"
        className={classes.checkbox}
        label={
          <Text className={classes.checkboxLabel}>
            {shortText}{' '}
            <TextButton
              as="button"
              // Prevent focus change on pointer down so the input doesn't blur before this action
              onPointerDown={(e) => e.preventDefault()}
              onClick={() => setIsExpanded(!isExpanded)}
              className={classes.link}
              data-hook="signup-read-more-link"
            >
              {isExpanded ? showLessText : showMoreText}
            </TextButton>
          </Text>
        }
      />
      {isExpanded && (
        <Text className={classes.checkboxLabel}>{expandedText}</Text>
      )}
    </div>
  );
};
